import * as React from 'react';
import { colors } from '../../../index';

const IconListings = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 46 46",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.769 1.769h42.462v5.308H1.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.577 0H4.423A4.428 4.428 0 000 4.423v35.385a2.657 2.657 0 002.654 2.654h17.692v-1.77H2.654a.885.885 0 01-.885-.884V38.76c.278.1.573.163.885.163h17.692v-1.77H2.654a.885.885 0 01-.885-.884V8.846h42.462V36.27a.885.885 0 01-.885.884H25.654v1.77h17.692c.312 0 .607-.065.885-.164v1.048a.885.885 0 01-.885.884H25.654v1.77h17.692A2.657 2.657 0 0046 39.808V4.423A4.428 4.428 0 0041.577 0zM1.769 7.077V4.423A2.657 2.657 0 014.423 1.77h37.154a2.657 2.657 0 012.654 2.654v2.654H1.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.692 19.462v-7.077c0-.976-.793-1.77-1.769-1.77H7.077c-.976 0-1.77.794-1.77 1.77v7.077c0 .975.794 1.769 1.77 1.769h31.846c.976 0 1.77-.794 1.77-1.77zm-1.767 0h-7.079v-7.077h7.077l.002 7.077zm-8.848 0H15.923v-7.077h14.154v7.077zm-23-7.077h7.077v7.077H7.077v-7.077zm19.878 21.23c.496 0 .95-.256 1.187-.668.224-.39.222-.854-.005-1.242l-3.53-6.052c-.32-.545-.935-.884-1.607-.884-.672 0-1.287.339-1.606.885l-3.53 6.05c-.227.389-.23.853-.005 1.243.236.412.69.668 1.186.668h3.07v9.731a.885.885 0 01-.884.885H5.308V46H21.23a2.657 2.657 0 002.654-2.654v-9.73h3.07zm-4.044-7.057c.035-.027.142-.028.167-.013l3.093 5.301H19.83l3.082-5.288zM5.308 24.769h10.615v1.769H5.308zm0 3.539h10.615v1.769H5.308zm0 3.538h8.846v1.769H5.308zm24.769-7.077h10.615v1.769H30.077zm0 3.539h10.615v1.769H30.077zm1.769 3.538h8.846v1.769h-8.846zM5.308 3.538h5.308v1.769H5.308zm7.077 0h3.538v1.769h-3.538z"
  })));
};

export default IconListings;